import { render, staticRenderFns } from "./OrderRecord.vue?vue&type=template&id=bdd287b4&scoped=true"
import script from "./OrderRecord.vue?vue&type=script&lang=js"
export * from "./OrderRecord.vue?vue&type=script&lang=js"
import style0 from "./OrderRecord.vue?vue&type=style&index=0&id=bdd287b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd287b4",
  null
  
)

export default component.exports